import apiClient from "@/services/axios";

export const fetchSupplierProfile = (id) =>
  apiClient.get(`/compV3/decaissement/suppliers/${id}`);

export const fetchSupplierInvoices = (id) =>
  apiClient.get(`/compV3/decaissement/suppliers/${id}/invoices`);

export const fetchSchedules = (depenseId) =>
  apiClient.get(`/compV3/decaissement/depenses/${depenseId}/schedules`);

export const createSchedules = (depenseId, schedules) =>
  apiClient.post(`/compV3/decaissement/depenses/${depenseId}/schedules`, {
    data: { schedules },
  });

/** Replaces all pending schedules; amounts must sum to (invoice total − paid) exactly. */
export const replacePendingSchedules = (depenseId, schedules) =>
  apiClient.put(`/compV3/decaissement/depenses/${depenseId}/schedules/pending-replace`, {
    data: { schedules },
  });

export const updateSchedule = (id, payload) =>
  apiClient.patch(`/compV3/decaissement/schedules/${id}`, { data: payload });

export const deleteSchedule = (id) =>
  apiClient.delete(`/compV3/decaissement/schedules/${id}`);
